"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.process = void 0;
var AppModel_1 = require("./App/AppModel");
var AutoModuleHelpers_1 = require("./autoModule/AutoModuleHelpers");
var AutoModuleTemplates_1 = require("./autoModule/AutoModuleTemplates");
var getConfigData_1 = require("./autoModule/getConfigData");
var autoModuleView_1 = require("./autoModule/views/autoModuleView");
var AnalyticsHelper_1 = require("./Analytics/AnalyticsHelper");
/**
 * @param initialModule
 * @param stage
 * @param getDerivedData
 */
var process = function (initialModule, stage, getDerivedData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var model = (0, AppModel_1.getModel)(initialModule, getDerivedData);
    if (!model)
        return initialModule;
    var processedOutput = __assign({}, initialModule);
    switch (stage) {
        case "arguments":
            processedOutput = __assign(__assign({}, processedOutput), { imports: (_a = model
                    .getImportInterfaces()
                    .createProcessedImports(stage)) !== null && _a !== void 0 ? _a : initialModule.imports });
            break;
        case "payloads":
            processedOutput = __assign(__assign({}, processedOutput), { exports: (_b = model
                    .getExportInterfaces()
                    .createProcessedExports()) !== null && _b !== void 0 ? _b : initialModule.exports, name: model.getName(), help: (_e = (_d = (_c = model === null || model === void 0 ? void 0 : model.getDerivedFunctions()) === null || _c === void 0 ? void 0 : _c.overrideModuleLevelHelp) === null || _d === void 0 ? void 0 : _d.call(_c)) !== null && _e !== void 0 ? _e : (0, getConfigData_1.getConfigData)(model).help });
            break;
        case "results":
            processedOutput = __assign(__assign({}, processedOutput), { imports: (_f = model
                    .getImportInterfaces()
                    .createProcessedImports(stage)) !== null && _f !== void 0 ? _f : initialModule.imports });
            break;
        case "views":
            {
                var customTemplateData = (_j = (_h = model === null || model === void 0 ? void 0 : (_g = model.getDerivedFunctions()).templateData) === null || _h === void 0 ? void 0 : _h.call(_g)) !== null && _j !== void 0 ? _j : {};
                var view = (0, autoModuleView_1.createAutoViewPayloads)(model);
                processedOutput = __assign(__assign({}, processedOutput), { payload: __assign(__assign({}, initialModule.payload), { auto: view, customView: (_l = (_k = model === null || model === void 0 ? void 0 : model.getDerivedFunctions()) === null || _k === void 0 ? void 0 : _k.getCustomView) === null || _l === void 0 ? void 0 : _l.call(_k, initialModule) }), templateData: customTemplateData, templates: (0, AutoModuleTemplates_1.getTemplates)(model), alerts: (_o = model === null || model === void 0 ? void 0 : (_m = model.getDerivedFunctions()).alerts) === null || _o === void 0 ? void 0 : _o.call(_m), name: model.getActiveName(), category: model.getCategory(), description: (_r = (_q = (_p = model === null || model === void 0 ? void 0 : model.getDerivedFunctions()) === null || _p === void 0 ? void 0 : _p.getModuleDescription) === null || _q === void 0 ? void 0 : _q.call(_p)) !== null && _r !== void 0 ? _r : (0, AutoModuleHelpers_1.getModuleDefaultDescription)(), globalNames: (_u = (_t = (_s = model === null || model === void 0 ? void 0 : model.getDerivedFunctions()) === null || _s === void 0 ? void 0 : _s.getGlobalNames) === null || _t === void 0 ? void 0 : _t.call(_s)) !== null && _u !== void 0 ? _u : [], analytics: (_x = (_w = (_v = model.getDerivedFunctions()).getAnalytics) === null || _w === void 0 ? void 0 : _w.call(_v)) !== null && _x !== void 0 ? _x : (0, AnalyticsHelper_1.getAnalyticsDefault)(model) });
            }
            break;
        default:
            return initialModule;
    }
    return processedOutput;
};
exports.process = process;
//# sourceMappingURL=processor.js.map